export default {
      id: "icon_star_active-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#icon_star_active-usage",
      toString: function () {
        return this.url;
      }
    }